import { render, staticRenderFns } from "./QuizHeader.vue?vue&type=template&id=75f528c3&scoped=true&lang=pug&"
import script from "./QuizHeader.vue?vue&type=script&lang=ts&"
export * from "./QuizHeader.vue?vue&type=script&lang=ts&"
import style0 from "./QuizHeader.vue?vue&type=style&index=0&id=75f528c3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f528c3",
  null
  
)

export default component.exports